import './CartItem.css';
import { get } from 'lodash';
import * as React from 'react';
import NotosService from '../../../../classes/notos.service';
import Config from '../../../../config/config';

const CartItem = ({ item, isListItem = true, isSample = false, sampleId = -1, isPackage = false , currencyLabel}) => {
    const PACK_NAME = 'ОПАКОВКА';
    const packaging = get(item, 'attributes.packaging', ''); // used for sample only
    // used for products variants only
    const subhead = get(item, 'attributes.product.attributes.subhead', '');
    const sku = get(item, 'attributes.variant.attributes.barcode', '');
    const price = get(item, isPackage ? 'price' : 'attributes.price', '0.00');
    const optionTypeDisplayType = get(item, 'attributes.product.attributes.option_type.attributes.display_type', '');
    const optionTypeName = get(item, 'attributes.product.attributes.option_type.attributes.name', '');
    const optionValue = get(item, 'attributes.variant.attributes.option_value.attributes.value', '');
    const colorImage = get(item, 'attributes.variant.attributes.color_image.attributes.image_url', null);
    const currency = currencyLabel === "eur" ? NotosService.EURO_CURRENCY : NotosService.CURRENCY
    // used for both
    const id = isSample && sampleId !== -1 ? sampleId : get(item, 'id', -1);
    const name = get(
        item,
        isSample || item.type === 'gift' ? 'attributes.name' : 'attributes.product.attributes.name',
        ''
    );
    const brandName = get(
        item,
        isSample || item.type === 'gift' ? 'attributes.brand' : 'attributes.product.attributes.brand_name',
        ''
    );
    const image =
        Config.cdnDomain +
        get(
            item,
            isSample || item.type === 'gift'
                ? 'attributes.image_url'
                : 'attributes.variant.attributes.images[0].attributes.image_url',
            ''
        );
    const deleteBtn = (
        <button className="delete-btn" onClick={() => onDelete(id)}>
            <i className="icon-delete-icon" />
        </button>
    );
    const quantity = get(item, 'attributes.quantity', 1);

   
    return (
        <div className="cart-item">
            {isPackage ? <i className="icon-package" /> : <img src={image} alt={name} title={name} />}

            <div className="details">
                <div className="details-inner">
                    {brandName ? <p className="title">{brandName}</p> : null}
                    <p className="title">{!isPackage ? name : PACK_NAME}</p>
                    {isSample && isListItem && !isPackage ? (
                        <div className="delete-wrap">
                            <span>{packaging}</span>
                        </div>
                    ) : isPackage ? (
                        <div className="delete-wrap">{deleteBtn}</div>
                    ) : (
                        <p className="text opt-val">{packaging}</p>
                    )}

                    {!isSample && !isPackage ? (
                        <div>
                            <p className="text">{subhead}</p>
                            <p className="text opt-val">
                                {optionTypeDisplayType === NotosService.DISPLAY_TYPE_COLOR && colorImage ? (
                                    <span
                                        style={{
                                            background: `url(${Config.cdnDomain + colorImage})`,
                                        }}
                                        className="variant-color"
                                    />
                                ) : null}
                                {optionValue}{' '}
                                {optionTypeDisplayType === NotosService.DISPLAY_TYPE_COLOR ? '' : optionTypeName}
                            </p>
                            <div className="delete-wrap">{item.type === 'gift' ? null : <span>SKU: {sku}</span>}</div>
                        </div>
                    ) : null}
                </div>

                {isListItem ? (
                    <div>
                        <span style={{ marginRight: '10px', fontSize: '17px' }}>{quantity} бр. -</span>
                        <span className="price title">
                            {price * quantity} {currency}
                        </span>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default CartItem;



// WEBPACK FOOTER //
// ./src/components/Orders/OrdersList/OrderDetails/CartItem.js